import Vue from 'vue'

// ui/collections

Vue.component('ui-button-collection', () => import('@hubsolv/hubsolv-ui').then(({ UiButtonCollection }) => UiButtonCollection ))

// ui/display

Vue.component('ui-card',              () => import('@hubsolv/hubsolv-ui').then(({ UiCard }) => UiCard ))
Vue.component('ui-color-dot',         () => import('@hubsolv/hubsolv-ui').then(({ UiColorDot }) => UiColorDot ))
Vue.component('ui-divider',           () => import('@hubsolv/hubsolv-ui').then(({ UiDivider }) => UiDivider ))
Vue.component('ui-empty-state',       () => import('@hubsolv/hubsolv-ui').then(({ UiEmptyState }) => UiEmptyState ))
Vue.component('ui-formatted-text',    () => import('@hubsolv/hubsolv-ui').then(({ UiFormattedText }) => UiFormattedText ))
Vue.component('ui-icon',              () => import('@hubsolv/hubsolv-ui').then(({ UiIcon }) => UiIcon ))
Vue.component('ui-label',             () => import('@hubsolv/hubsolv-ui').then(({ UiLabel }) => UiLabel ))
Vue.component('ui-loading-animation', () => import('./ui/display/UiLoadingAnimation.vue'))
Vue.component('ui-loading-overlay',   () => import('@hubsolv/hubsolv-ui').then(({ UiLoadingOverlay }) => UiLoadingOverlay ))
Vue.component('ui-status-icon',       () => import('@hubsolv/hubsolv-ui').then(({ UiStatusIcon }) => UiStatusIcon ))

// ui/inputs

Vue.component('ui-button',            () => import('@hubsolv/hubsolv-ui').then(({ UiButton }) => UiButton ))
Vue.component('ui-dropdown',          () => import('@hubsolv/hubsolv-ui').then(({ UiDropdown }) => UiDropdown ))
Vue.component('ui-icon-button',       () => import('@hubsolv/hubsolv-ui').then(({ UiIconButton }) => UiIconButton ))
Vue.component('ui-menu',              () => import('@hubsolv/hubsolv-ui').then(({ UiMenu }) => UiMenu ))
Vue.component('ui-multi-select',      () => import('@hubsolv/hubsolv-ui').then(({ UiMultiSelect }) => UiMultiSelect ))
Vue.component('ui-pill-button',       () => import('@hubsolv/hubsolv-ui').then(({ UiPillButton }) => UiPillButton ))
Vue.component('ui-text-input',        () => import('@hubsolv/hubsolv-ui').then(({ UiTextInput }) => UiTextInput ))
Vue.component('ui-label-wrapper',     () => import('@hubsolv/hubsolv-ui').then(({ UiLabelWrapper }) => UiLabelWrapper ))
Vue.component('ui-error-wrapper',     () => import('@hubsolv/hubsolv-ui').then(({ UiErrorWrapper }) => UiErrorWrapper ))

// ui/list

Vue.component('ui-list',              () => import('@hubsolv/hubsolv-ui').then(({ UiList }) => UiList ))
Vue.component('ui-list-item',         () => import('@hubsolv/hubsolv-ui').then(({ UiListItem }) => UiListItem ))

// ui/modal

Vue.component('ui-modal',             () => import('@hubsolv/hubsolv-ui').then(({ UiModal }) => UiModal ))

// templates
Vue.component('template-view',        () => import('@/templates/TemplateView.vue'))
